export const config = {
  VITE_STRAPI_FRONTEND_PUBLIC_ACCESS_API_TOKEN:
    '03e365a302270b2d528b606e684772c2e7d62c71845f32e6cc8e0c0decac4bacd86566659e3a02d72bdc9d759643dc986a922aed8ecabd4a8ebcfd000e72ee37222fea14c6a5d1b2bc7e0cf8a9997c983e2a99de9eb79628d28d6a6d06894bcec58f4cc2414e00e0ecc3e9fb313b4cf270179ddee4c3e95e83d80b09e6915c1d',
};
